import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-[#2a4692] text-white py-6 px-6 border-t border-[#1d3166]">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-xs md:text-sm">
        <div className="text-center md:text-left">
          Ring <span className="whitespace-nowrap font-semibold">50 358 378</span> eller send en mail på <span className="whitespace-nowrap font-semibold">info@dansketelemasterinvest.dk</span>
        </div>
        <div className="text-slate-300 text-[11px] uppercase tracking-wider text-center md:text-right flex flex-col md:items-end gap-1">
          <div>© {new Date().getFullYear()} KnowHow GROUP. Alle rettigheder forbeholdes. · CVR: 21810797</div>
          <div className="text-slate-400 text-[10px] normal-case">Danske Telemaster er en del af KnowHow GROUP</div>
        </div>
      </div>
    </footer>
  );
}
